import { AfterViewInit, Component, Input, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import * as moment from 'moment/moment'
import {FormGenerateModel} from './form-generate.model';
import {FormItemType} from '../controls/vss-control.enum';
import {Ultilities} from '../../extensions/ultilities';

@Component({
  selector: 'vss-ui-form-generate[formFields]',
  templateUrl: './form-generate.component.html',
  styleUrls: ['./form-generate.component.scss']
})
export class FormGenerateComponent implements OnInit, AfterViewInit {
  @Input() formFields: FormGenerateModel[] = []
  @Input() dataPatch: any
  @Input () colGroup = 12 // Max 24
  /***
   *
   * @param labelCol giá trị từ 1 - 24
   *
   ***/
  @Input() labelCol = 24
  /***
   *
   * @param controlCol giá trị từ 1 - 24
   *
   ***/
  @Input() controlCol = 24
  MAX_LENGTH_TEXT = 256
  formGroup: FormGroup = this.fb.group({})
  formItemType = FormItemType
  colDateTypes: FormItemType[] = [
    FormItemType.DATE_PICKER,
    FormItemType.DATE_PICKER,
    FormItemType.DATE_TIME_PICKER,
    FormItemType.DATE_TIME_RANGE_PICKER,
    FormItemType.DATE_RANGE_PICKER,
  ]
  currentTime = moment().format('X')
  constructor(
    private fb: FormBuilder
  ) { }


  ngAfterViewInit(): void {
    setTimeout(()=>{
      const fieldFocus = this.formFields
        .map(f => ({
          ...f,
          selectorHtml: (document.querySelector('#' + f.field + '_' + this.currentTime + ' input')
            || document.querySelector('#' + f.field + '_' + this.currentTime + ' texarea')) as HTMLInputElement
        }))
        .find(f => f.autoFocus && !!f.selectorHtml)
      fieldFocus?.selectorHtml?.focus()
    }, 400)
  }

  ngOnInit(): void {
    this.initForm()
  }
  initForm() {
    this.formGroup = this.fb.group({})
    this.formFields.forEach((field: any) => {
      this.formGroup.addControl(field.field, this.fb.control(
        { value: field.value || (this.dataPatch ? this.dataPatch[field.field] : null), disabled: field.disable },
        [...(field.required ? [Validators.required] : []), ...(field.validators || [])])
      )
    })
    if(this.dataPatch) {
      this.formGroup.patchValue(this.dataPatch)
    }
  }
  validateForm() {
    Ultilities.validateForm(this.formGroup)
    return !this.formGroup.invalid
  }
}
